export function buildPages(currentPage, totalPages, edgeCount = 2, siblingCount = 1) {
    const pages = new Set();

    // always show first/last edges
    for (let i = 1; i <= Math.min(edgeCount, totalPages); i++) pages.add(i);
    for (let i = Math.max(1, totalPages - edgeCount + 1); i <= totalPages; i++) pages.add(i);

    // show neighbors around current
    const start = Math.max(1, currentPage - siblingCount);
    const end   = Math.min(totalPages, currentPage + siblingCount);
    for (let i = start; i <= end; i++) pages.add(i);

    // turn into sorted array
    const sorted = [...pages].sort((a, b) => a - b);

    // inject ellipses
    const out = [];
    for (let i = 0; i < sorted.length; i++) {
        const prev = sorted[i - 1];
        const cur = sorted[i];
        if (prev && cur - prev > 1) out.push('…'); // gap
        out.push(cur);
    }
    return out;
}
